import Swiper, { Navigation, Pagination, Thumbs } from 'swiper';

Swiper.use([Navigation, Pagination, Thumbs]);

const SWIPER_MAIN_CLASS = 'swiper-main';

const InitializeSwiper = (carousel, slides, uniqueClassMain) => {
    const mainClass = `.property-carousel-block ${uniqueClassMain ? `.${uniqueClassMain}` : '.swiper-main'}`;
    const floorplanIndex = slides.length - 2;
    const villageMapIndex = slides.length - 1;

    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const mainSwiper = new Swiper(mainClass, {
        spaceBetween: 24,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination-property',
            type: 'fraction'
        },
        autoHeight: true,
        on: {
            slideChange: () => {
                if (mainSwiper.activeIndex === floorplanIndex) {
                    toggleActiveNavItems('floorplan');
                } else if (mainSwiper.activeIndex === villageMapIndex) {
                    toggleActiveNavItems('village-map');
                } else {
                    // just remove all active buttons
                    toggleActiveNavItems();
                }
            }
        }
    });

    const carouselCover = carousel.querySelector('.property-carousel-cover');
    const carouselContainer = carousel.querySelector('.property-carousel');
    const exitCarousel = carouselContainer.querySelector('.exit-carousel');

    carouselCover.addEventListener('click', () => {
        carouselContainer.style.display = 'flex';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${window.scrollY}px`;

        if (mainSwiper.activeIndex === floorplanIndex) {
            toggleActiveNavItems('floorplan');
        } else if (mainSwiper.activeIndex === villageMapIndex) {
            toggleActiveNavItems('village-map');
        } else {
            // just remove all active buttons
            toggleActiveNavItems();
        }
    });

    exitCarousel.addEventListener('click', () => {
        carouselContainer.style.display = 'none';

        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
    });

    const imageBtn = carousel.querySelector('.images');
    const floorplanBtns = carousel.querySelectorAll('.floorplan');
    const villageMapBtns = carousel.querySelectorAll('.village-map');

    imageBtn.addEventListener('click', () => {
        if (mainSwiper.activeIndex === floorplanIndex) {
            toggleActiveNavItems('floorplan');
        } else if (mainSwiper.activeIndex === villageMapIndex) {
            toggleActiveNavItems('village-map');
        } else {
            // just remove all active buttons
            toggleActiveNavItems();
        }
    });

    Array.from(floorplanBtns).forEach(btn => {
        btn.addEventListener('click', () => {
            mainSwiper.slideTo(floorplanIndex);

            toggleActiveNavItems('floorplan');
        });
    });

    Array.from(villageMapBtns).forEach(btn => {
        btn.addEventListener('click', () => {
            mainSwiper.slideTo(villageMapIndex);

            toggleActiveNavItems('village-map');
        });
    });
};

// Apply active styling on cliced navigation item
const toggleActiveNavItems = className => {
    const activeNav = document.querySelectorAll('.active');
    Array.from(activeNav).forEach(item => {
        item.classList.remove('active');
    });

    const selectedItems = document.querySelectorAll(`.${className}`);
    Array.from(selectedItems).forEach(item => {
        item.classList.add('active');
    });
};

const PrepareCarousel = () => {
    const mcBlocks = document.querySelectorAll('.property-carousel-block');

    mcBlocks.forEach((mcBlock, index) => {
        const mainSwiper = mcBlock.querySelector('.swiper-main');
        const mainSwiperWrapper = mainSwiper ? mainSwiper.querySelector('.swiper-main .swiper-wrapper') : null;
        const swiperSlides = mainSwiperWrapper.querySelectorAll('.swiper-slide');

        if (mainSwiperWrapper) {
            // Add carousel length
            const imageCountElements = mcBlock.querySelectorAll('.item-count');

            Array.from(imageCountElements).forEach(el => {
                el.textContent = mainSwiperWrapper.children.length;
            });

            if (swiperSlides.length < 2) {
                // less than two slide, hide thumbnail
                mainSwiper?.classList.add('one-slide');
            } else {
                // more than one slide, copy slides to thumbnail carousel
                const uniqueClassMain = `${SWIPER_MAIN_CLASS}-${index}`;
                mainSwiper?.classList.add(uniqueClassMain);
                InitializeSwiper(mcBlock, swiperSlides, uniqueClassMain);
            }
        }
    });
};

// Run the functions on document ready
document.addEventListener('DOMContentLoaded', PrepareCarousel);
